import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    get_job_list,
    setSearchQuery,
    setSearchColumn,
    get_job_detail,
    proof_log_table,
    setJobData,
    send_proof,
    get_job_messages,
    get_sidebar_menu,
    setDateRange,
    setCorrectionType,
    clearSearchFilters
} from "../../../store/job/jobSlice";


import {
    setStageTab,
    setProcessTab,
    get_company_process,
    setProcessHasJobForm,
    get_company_process_stage
} from "../../../store/user/userSlice";


const mapStateToProps = (state) => {
    const { selected_stage_tab, selected_process_tab, selected_company, company_process } = state.user;
    const { job_list, total_job_count, common_loading, search_query, search_column, search_columns, table_columns, searchFilters, clearJobData, job_detail, proof_log_data, fromDate, toDate, correctionType } = state.job;
    return {
        selected_process_tab: selected_process_tab,
        selected_stage_tab: selected_stage_tab,
        selected_company: selected_company,
        company_process,
        job_list,
        job_total: total_job_count,
        common_loading,
        searchFilters,
        search_query: search_query,
        search_column: search_column,
        search_columns: search_columns,
        table_columns: table_columns,
        clearJobData: clearJobData,
        job_detail: job_detail,
        proof_log_data: proof_log_data,
        fromDate,
        toDate,
        correctionType
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            get_job_list,
            setSearchQuery,
            setSearchColumn,
            get_job_detail,
            proof_log_table,
            setJobData,
            setStageTab,
            setProcessTab,
            get_company_process,
            setProcessHasJobForm,
            send_proof,
            get_job_messages,
            get_sidebar_menu,
            get_company_process_stage,
            setDateRange,
            setCorrectionType,
            clearSearchFilters
        },
        dispatch
    );


const Store = (Container) =>
    connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;